import HttpRequest from './HttpRequest';

export default class CountryService extends HttpRequest {
  static endpoint = 'countries';

  static async getAll() {
    this.endpoint = 'countries?all=true';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'countries';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'countries';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'countries';
    const response = await this.put(id, data);
    return response;
  }
}
